module.exports = __webpack_public_path__ + "static/media/Mobile-Lounge.6a4b2cc8.jpg";